function textEllipsis(str, maxLength, { side = "end", ellipsis = "..." } = {}) {
    if (str.length > maxLength) {
        switch (side) {
            case "start":
                return ellipsis + str.slice(-(maxLength - ellipsis.length));
            case "end":
            default:
                return str.slice(0, maxLength - ellipsis.length) + ellipsis;
        }
    }
    return str;
}

$(function () {

    let searchValue = '';
    let searchRequestId = 0;
    let searchItemsContent = $('#searchItems');
    let searchItemsMobileContent = $('#searchItemsMobile');


    $('body').on('keyup', '.searchInput, #searchInputMobile', delay(function (e) {
        liveSearch($(this).val(), $("#searchItems, #searchItemsMobile"));
    }, 100));

    $(".search-form").on('submit', function (e) {
        e.preventDefault();
        window.location.href = '/search-result?product-name=' + searchValue;
    });

    $(document).click(function (event) {
        var $target = $(event.target);
        if (!$target.closest('.search-form').length &&
            $('.search-form').is(":visible")) {
            searchItemsContent.removeClass('d-block');
            searchItemsMobileContent.removeClass('d-block');
        }
    });

    function delay(callback, ms) {
        var timer = 0;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }

    const liveSearch = (val, contents) => {
        let requestId = ++searchRequestId;
        const searchItemsContent = contents

        try {
            searchValue = val;

            if (val === '') {
                searchItemsContent.removeClass('d-block');
                return;
            }

            $.ajax({
                url: '/search?val=' + val,
                type: 'GET',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    let output = '';

                    $.each(data.products, function (key, product) {
                        output += `
                          <a href="/${product.slug}" class="search-item">
                            <img src="${product.image?.url ? product.image.url : ''}" class="img-fluid">
                            <div class="search-item-body">
                              <h4 class="title text-black">${product.name}</h4>
                              <p class="subtitle text-muted text-left">${textEllipsis(product.short_description.replace(/<[^>]*>?/gm, ''), 70)}</p>
                            </div>
                          </a>
                        `;
                    });
                    
                    // Forgot requests if there is a new one
                    if (requestId === searchRequestId) {
                        searchItemsContent.empty();
                        searchItemsContent.append(output);
                    }

                    if (data.products.length > 0) {
                        searchItemsContent.addClass('d-block');
                    } else {
                        searchItemsContent.removeClass('d-block');
                    }
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
});
